export const environment = {
    API_URL:'https://api.kinomap.dev/v4/',
    APP_TOKEN:'xBNAlgmATTrT8WnT1OLepTKpVFWd0Fy8nnkYHQQjFFpYlDzNB8EExRsP8XY10eeIN2oQihxUEWH2ELQAWXyGueJuiDWraXCKsBqoiJJez4PadP4q0xvrNyCy'
};
